// Defaults that depend on where the game is hosted. Poki serves a younger
// audience: blood defaults to rainbow there and character voices stay off,
// with the voices toggle locked. Kept free of imports so it can be used from
// the save manager and unit-tested headlessly.

export const detectPokiHost = ({hostname = '', search = ''} = {}) => {
	const params = new URLSearchParams(search);
	return hostname.toLowerCase().includes('poki') || Boolean(params.get('pokiDebug'));
};

// Detected as soon as this module loads. Some modules read the save while they
// load (TutorialManager, the editor UI), well before gameInit runs, and that
// first read creates the save from these defaults. Detecting any later would
// write the off-Poki defaults into a fresh save, and a stored value wins.
const currentLocation = () => (typeof window !== 'undefined' && window.location ? window.location : {});
const state = {onPoki: detectPokiHost(currentLocation())};

export const setPlatformDefaults = ({onPoki = false} = {}) => {
	state.onPoki = Boolean(onPoki);
	return {...state};
};

export const isPokiHost = () => state.onPoki;

// Defaults for a fresh save. A stored choice always wins over these.
export const platformUserDefaults = () => ({bloodOn: !state.onPoki});

// On Poki the voices are off and the toggle cannot change that.
export const vocalsLockedOff = () => state.onPoki;

export const resolveDisableVocals = vocalsOn => vocalsLockedOff() || !vocalsOn;
